import { render } from "./BillsTable.vue?vue&type=template&id=3964d457&scoped=true"
import script from "./BillsTable.vue?vue&type=script&lang=js"
export * from "./BillsTable.vue?vue&type=script&lang=js"

import "./BillsTable.vue?vue&type=style&index=0&id=3964d457&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3964d457"]])

export default __exports__